import { render, staticRenderFns } from "./MassUploadCostsModal.vue?vue&type=template&id=65c3888a&scoped=true&"
import script from "./MassUploadCostsModal.vue?vue&type=script&lang=js&"
export * from "./MassUploadCostsModal.vue?vue&type=script&lang=js&"
import style0 from "./MassUploadCostsModal.vue?vue&type=style&index=0&id=65c3888a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3888a",
  null
  
)

export default component.exports